import {ID_PREFIX_BY_CONFIG_KEY} from '~/ads/constants';
import {getAdDimensions} from '~/ads/utils';

export enum AdConfigKey {
  TOP_LEADERBOARD = 'topLeaderboard',
  LEADERBOARD = 'leaderboard',
  SIDE_PANEL = 'sidePanel',
  PHOTO_SHARE = 'photoShare',
  PHOTO_SHARE_GALLERY = 'photoShareGallery',
  CREATE_FLOW_DESKTOP = 'createFlowDesktop',
  CREATE_FLOW_MOBILE = 'createFlowMobile',
  VIEW_INVITE_TOP_DESKTOP = 'viewInviteTopDesktop',
  VIEW_INVITE_TOP_MOBILE = 'viewInviteTopMobile',
  VIEW_INVITE_MID_DESKTOP = 'viewInviteMidDesktop',
  VIEW_INVITE_MID_MOBILE = 'viewInviteMidMobile',
  VIEW_INVITE_BOTTOM_DESKTOP = 'viewInviteBottomDesktop',
  VIEW_INVITE_BOTTOM_MOBILE = 'viewInviteBottomMobile',
}

interface GetAdConfigParams {
  index: number;
  isLargishAndUp: boolean;
  configKey: AdConfigKey;
}

export interface AdConfig {
  adPlacementName: string;
  adSlotUrl: string;
  dimensions: number[][];
}

export const getAdConfig =({index, isLargishAndUp, configKey}: GetAdConfigParams): AdConfig => {
    const {dfp} = evite;
    const sidePanel = configKey === AdConfigKey.SIDE_PANEL;
    const GoogleBannerAdIdWithIndex = `${ID_PREFIX_BY_CONFIG_KEY[configKey]}${index ? `-${index}` : ''}`;
    const adUnitId = isLargishAndUp || sidePanel ? dfp.DESKTOP_ID : dfp.MOBILE_ID;
    const adSlotUrl = dfp.compactUrl(adUnitId, GoogleBannerAdIdWithIndex);

    const dimensions = getAdDimensions(configKey, isLargishAndUp);
    return {
        adPlacementName: GoogleBannerAdIdWithIndex,
        adSlotUrl,
        dimensions,
    };
};
